module.exports = __webpack_public_path__ + "static/07-f0a5204ab7c37b2bacd575889eef57ad.jpg";